<template>
  <div class="section pt-5">
    <medical-service-datatable ref="bed_datatable"></medical-service-datatable>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import MedicalServiceDatatable from "./medical_service_datatable/Index.vue";

export default {
  name: "PatientMedicalService",
  components: { MedicalServiceDatatable },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
